import { z } from 'zod';

export const MeetingFormSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    details: z.string().optional(),
    startDateTime: z.number().nullable(),
    endDateTime: z.number().nullable(),
    timezone: z.string(),
    location: z.string(),
    owner: z.object({ id: z.string(), name: z.string() }),
    fabricator: z.object({ id: z.string(), name: z.string() }),
    attendees: z
      .array(z.object({ id: z.string(), name: z.string() }))
      .max(20, 'You can add up to 20 attendees'),
  })
  .superRefine((data, ctx: any) => {
    if (!data.title?.trim()) {
      ctx.addIssue({
        path: ['title'],
        message: 'This field is required',
        code: 'custom',
      });
    }

    if (!data.location?.trim()) {
      ctx.addIssue({
        path: ['location'],
        message: 'This field is required',
        code: 'custom',
      });
    }

    if (!data.fabricator?.id) {
      ctx.addIssue({
        path: ['fabricator'],
        message: 'This field is required',
        code: 'custom',
      });
    }

    if (data.startDateTime === null || data.startDateTime === undefined) {
      ctx.addIssue({
        path: ['startDateTime'],
        message: 'This field is required',
        code: 'custom',
      });
    }

    if (data.endDateTime === null || data.endDateTime === undefined) {
      ctx.addIssue({
        path: ['endDateTime'],
        message: 'This field is required',
        code: 'custom',
      });
    }
  });

export const MeetingRescheduleFormSchema = z
  .object({
    startDateTime: z.number().nullable(),
    endDateTime: z.number().nullable(),
    reason: z.string(),
  })
  .superRefine((data, ctx: any) => {
    if (data.startDateTime === null || data.startDateTime === undefined) {
      ctx.addIssue({
        path: ['startDateTime'],
        message: 'This field is required',
        code: 'custom',
      });
    }
    if (data.endDateTime === null || data.endDateTime === undefined) {
      ctx.addIssue({
        path: ['endDateTime'],
        message: 'This field is required',
        code: 'custom',
      });
    }
    if (
      data.startDateTime !== null &&
      data.startDateTime !== undefined &&
      data.endDateTime !== null &&
      data.endDateTime !== undefined &&
      data.endDateTime <= data.startDateTime
    ) {
      ctx.addIssue({
        path: ['endDateTime'],
        message: 'End time must be after start time',
        code: 'custom',
      });
    }
    if (!data.reason?.trim()) {
      ctx.addIssue({
        path: ['reason'],
        message: 'This field is required',
        code: 'custom',
      });
    }
  });

export const MeetingCancelFormSchema = z
  .object({
    reason: z.string(),
  })
  .superRefine((data, ctx: any) => {
    if (!data.reason?.trim()) {
      ctx.addIssue({
        path: ['reason'],
        message: 'This field is required',
        code: 'custom',
      });
    }
  });
